// frontend/src/services/core/CommandFactory.js
import { ApiClient } from './ApiClient.js';
import { GenericCommandService } from '../commands/GenericCommandService.js';
import { NestHubCommandService } from '../commands/NestHubCommandService.js';

/**
 * Factory do tworzenia odpowiednich serwisów komend na podstawie typu urządzenia
 */
export class CommandFactory {
  constructor() {
    this.apiClient = new ApiClient();
    this.commandServices = new Map();
    
    // Zarejestruj dostępne serwisy komend
    this.registerCommandService('generic', GenericCommandService);
    this.registerCommandService('NestHub', NestHubCommandService);
  }

  /**
   * Zarejestruj nowy serwis komend dla typu urządzenia
   */
  registerCommandService(deviceType, ServiceClass) {
    this.commandServices.set(deviceType, ServiceClass);
  }

  /**
   * Pobierz serwis komend dla danego typu urządzenia
   */
  getCommandService(deviceType = 'generic') {
    const ServiceClass = this.commandServices.get(deviceType);
    
    if (!ServiceClass) {
      console.warn(`No command service found for device type: ${deviceType}, using generic`);
      return new GenericCommandService(this.apiClient);
    }
    
    return new ServiceClass(this.apiClient);
  }

  /**
   * Sprawdź czy serwis komend jest dostępny dla danego typu urządzenia
   */
  hasCommandService(deviceType) {
    return this.commandServices.has(deviceType);
  }

  /**
   * Pobierz listę wszystkich dostępnych typów urządzeń
   */
  getSupportedDeviceTypes() {
    return Array.from(this.commandServices.keys());
  }

  /**
   * Pobierz serwis API (dla kompatybilności wstecznej)
   */
  getApiClient() {
    return this.apiClient;
  }
}

// Singleton instance
export const commandFactory = new CommandFactory();
